import React, { useContext } from 'react';
import { Redirect, Route } from 'react-router-dom';

import UserContext from '../../../contexts/UserContext';
import { GUEST_PENDING_PATH, canGuestReachPath } from '../../../neighbors/utils/guestAccessRouting';

const PrivateRoute = ({ component, path, exact = false, guestAllowed = false }) => {
    const {
        userObject: { authenticated, userType, guestAccess },
    } = useContext(UserContext);
    if (!authenticated) {
        return <Redirect to={{ pathname: '/login' }} />;
    }
    if (path.includes('/login')) return <Redirect to={{ pathname: '/activities' }} />;
    const isGuest = userType === 'guest';
    if (isGuest && !canGuestReachPath(path, guestAccess)) {
        return <Redirect to={{ pathname: GUEST_PENDING_PATH }} />;
    }
    // Guests see only routes explicitly opted in via guestAllowed - new routes are hidden by default.
    if (isGuest && !guestAllowed) {
        return <Redirect to={{ pathname: '/' }} />;
    }
    return <Route path={path} component={component} exact={exact} />;
};

export default PrivateRoute;
